// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  objKey: __t.string().primaryKey().name("obj_key"),
  opId: __t.u64().name("op_id"),
  template: __t.string(),
  allocSov: __t.i64().name("alloc_sov"),
  slotsJson: __t.string().name("slots_json"),
  accepted: __t.u32(),
  state: __t.string(),
  beneficiary: __t.identity(),
  crewJson: __t.string().name("crew_json"),
  splitRev: __t.u32().name("split_rev"),
  target: __t.string(),
  resultText: __t.string().name("result_text"),
  completedAt: __t.timestamp().name("completed_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
